<template>
  <Bar :chart-data="chartData" :chart-options="chartOptions" :styles="styles"/>
</template>

<script>
import { Bar } from 'vue-chartjs'
import Chart from 'chart.js/auto'
import Vue from "vue";

export default {
      components: {
        Bar
      },
      props: {
            chartdata: {
                  type: Object,
                  default: null
            },
            options: {
                  type: Object,
                  default: null
            },
            colors: {
                  type: Array
            },
            styles: {
                  type: Object,
                  default: () => {}
            }
      },
      data() {
            let extendedOptions = structuredClone(this.options)
            let extendedChartData = structuredClone(this.chartdata)
            extendedOptions.scales.xAxis1.stacked = true
            extendedOptions.scales.y.stacked = true
            extendedOptions.plugins.legend.display = true
            extendedOptions.plugins.legend.position = 'left'
            extendedOptions.plugins.legend.fullSize = false
            extendedOptions.plugins.tooltip.callbacks.footer = function (tooltipItems) {
              let sum = 0
              extendedChartData.datasets.forEach((dataset) => {
                sum += dataset.data[tooltipItems[0].dataIndex]
              })
              return Math.round(extendedChartData.datasets[tooltipItems[0].datasetIndex].data[tooltipItems[0].dataIndex]/sum * 100) + '%'
            }
            extendedOptions.responsive = true
            extendedOptions.maintainAspectRatio = false
            Chart.defaults.elements.bar.borderWidth = 0

            const summator = (accumulator, current) => accumulator + current
            extendedChartData.datasets.sort((a, b) => b.data.reduce(summator) - a.data.reduce(summator))
            if (extendedChartData.datasets.length > Vue.Constants.STACKING_THRESHOLD) {
              const datumLength = extendedChartData.datasets[0].data.length
              let otherCumulated = extendedChartData.datasets.slice(Vue.Constants.STACKING_THRESHOLD).reduce((acc, curr) => {
                curr.data.forEach((el, i) => acc[i] += el)
                return acc
              }, Array(datumLength).fill(0))
              extendedChartData.datasets = extendedChartData.datasets.slice(0, Vue.Constants.STACKING_THRESHOLD + 1)
              extendedChartData.datasets[Vue.Constants.STACKING_THRESHOLD].data = otherCumulated
              extendedChartData.datasets[Vue.Constants.STACKING_THRESHOLD].label = 'Other'
            }
            extendedChartData.datasets.forEach((v, i) => v.backgroundColor = this.colors[i % this.colors.length])
            return {
              chartData: extendedChartData,
              chartOptions: extendedOptions
            }
      }
}
</script>